export default {"src":"/_next/static/media/whatsapp-icon.e8a757a8.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};